module.exports = __webpack_public_path__ + "img/ic-local-bank.b2f792cb.png";